module.exports = __webpack_public_path__ + "static/media/Ellipse 16.699b77e8.png";